import { cn } from "@/lib/utils";
import type { RunPhase } from "@/api/types";

const PHASES: RunPhase[] = ["resolving", "generating", "pushing_history", "pushing_alerts", "idle"];

export function RunPhaseStepper({ phase }: { phase: RunPhase | null }) {
  const currentIdx = phase ? PHASES.indexOf(phase) : -1;
  return (
    <div className="flex items-center gap-2">
      {PHASES.map((p, i) => (
        <div key={p} className="flex items-center gap-2">
          <div
            className={cn(
              "px-2 py-1 rounded text-xs",
              i <= currentIdx ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground",
            )}
          >
            {p}
          </div>
          {i < PHASES.length - 1 && <div className="w-3 h-px bg-border" />}
        </div>
      ))}
    </div>
  );
}
